"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _helper = _interopRequireDefault(require("../js/helper.js"));

var _errors = require("../js/errors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import api from '../js/api.js'
var search = {
  state: {
    apiToken: '',
    gotBaseData: false
  },
  getters: {
    token: function token(state) {
      return state.apiToken;
    },
    authenticated: function authenticated(state) {
      if (state.apiToken) {
        return true;
      } else {
        return false;
      }
    },
    gotBaseData: function gotBaseData(state) {
      return state.gotBaseData;
    }
  },
  mutations: {
    setToken: function setToken(state, data) {
      state.apiToken = data.access_token;
    },
    toggleBaseDataState: function toggleBaseDataState(state) {
      if (state.gotBaseData) {
        state.gotBaseData = false;
      } else {
        state.gotBaseData = true;
      }
    }
  },
  actions: {
    login: function login(context) {
      var credentials = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return context.getters.api.user.login(credentials.username, credentials.password).then(function (r) {
        var token = r.data;
        context.commit('setToken', r.data);
        return token;
      }).then(function (token) {
        context.dispatch('getBaseData');
        return token;
      });
    },
    getBaseData: function getBaseData(context) {
      if (!context.getters.gotBaseData && context.getters.authenticated) {
        context.dispatch('fetchCapitalTypes');
        context.dispatch('fetchProviderTypes');
        context.dispatch('fetchCountries');
        context.dispatch('fetchSectors');
        context.dispatch('fetchStats');
        context.dispatch('fetchDescriptions');
        context.dispatch('fetchSocialMedias');
        context.dispatch('fetchLanguages');
        context.dispatch('fetchCurrencies');
        context.dispatch('fetchCompanies');
        context.dispatch('fetchproviderList');
        context.commit('toggleBaseDataState');
      }
    },
    logout: function logout(context) {
      return context.getters.api.user.logout(context.getters.token).then(function (r) {
        context.commit('setToken', '');
      })["catch"](function (err) {
        if (err.message = 'Bad Request') {
          context.commit('setToken', '');
        }
      });
    }
  }
};
var _default = search;
exports["default"] = _default;


// WEBPACK FOOTER //
// ../capital-finder-vuex/lib/modules/user.js